module.exports = __webpack_public_path__ + "img/select.47d1db58.svg";